<template>
  <div class="space-y-4 my-5">
    <div
      v-for="plan in plans"
      :key="plan.id"
      class="hover:ring-2 hover:ring-primary-500 relative block cursor-pointer rounded-lg border-2 bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between"
      :class="isCurrentPlan(plan) ? 'border-primary-700' : 'hover:border-gray-500'"
      @click="$emit('input', plan.id)"
    >
      <span class="flex items-center">
        <span class="flex flex-col text-sm">
          <span class="font-medium text-gray-900">
            {{ plan.name }}
          </span>

          <span class="text-gray-500">
            <span class="block sm:inline">
              R$ {{ plan.price_per_consultation | currency }} por consulta
            </span>
          </span>
        </span>
      </span>

      <span class="mt-2 flex text-sm sm:mt-0 sm:ml-4 sm:flex-col sm:text-right">
        <span class="font-medium text-gray-900">
          R$ {{ plan.price / 100 }}
        </span>

        <span class="ml-1 text-gray-500 sm:ml-0">/mês</span>
      </span>
    </div>
  </div>
</template>

<script>
import currency from '@/support/filters/currency';

export default {
  props: {
    value: {
      type: [Number, String],
      default: null,
    },

    plans: Array,
  },

  data() {
    return {
      currentPlan: null,
    };
  },

  methods: {
    isCurrentPlan(plan) {
      return this.value === plan.id;
    },
  },

  filters: {
    currency,
  },
};
</script>
